import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Leaf, ArrowRight } from 'lucide-react';

export const ESGCard = ({ index }) => {
  const navigate = useNavigate();

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] }
    }
  };

  const handleCardClick = () => {
    navigate('/esg-training-course');
  };

  return (
    <motion.div
      variants={cardVariants}
      className="relative h-[420px]"
    >
      <motion.div
        className="relative h-full bg-white rounded-2xl shadow-md cursor-pointer overflow-hidden border-2 border-transparent hover:shadow-xl hover:scale-[1.02] transition-all duration-300"
        onClick={handleCardClick}
        whileHover={{ borderColor: 'rgba(16, 185, 129, 0.2)' }}
      >
        <div className="p-6 h-full flex flex-col">
          {/* Icon with gradient background */}
          <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 flex items-center justify-center mb-4 shadow-lg">
            <Leaf className="h-8 w-8 text-white" />
          </div>

          {/* Badge */}
          <div className="inline-block px-3 py-1 rounded-full text-xs font-semibold text-emerald-700 bg-emerald-50 self-start mb-3">
            Sustainability
          </div>

          {/* Title */}
          <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
            ESG Training Course
          </h3>

          {/* Gradient underline */}
          <div className="h-1 w-16 bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 rounded-full mb-4"></div>

          {/* Description */}
          <p className="text-gray-600 text-sm leading-relaxed flex-1 line-clamp-4">
            Master Environmental, Social, and Governance (ESG) principles to drive sustainable business practices. Learn ESG frameworks, reporting standards, and responsible governance for long-term value creation.
          </p>

          {/* Key Features */}
          <div className="flex flex-wrap gap-2 mt-3 mb-3">
            <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-700 rounded">Environmental</span>
            <span className="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-700 rounded">Social</span>
            <span className="px-2 py-1 text-xs font-medium bg-purple-100 text-purple-700 rounded">Governance</span>
          </div>

          {/* View Details Link */}
          <div className="flex items-center gap-2 text-emerald-600 font-semibold text-sm mt-2">
            <span>View Training Details</span>
            <ArrowRight className="h-4 w-4" />
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};
